import React from 'react';
import classnames from 'classnames';

const EmptyState = ({ className, message = 'Please check back soon' }) => (
  <p
    className={classnames(
      'font-bold text-center text-gray-600 text-lg',
      className
    )}
  >
    {message}
  </p>
);

export default EmptyState;
